import { createSlice, combineReducers } from '@reduxjs/toolkit'

import { loadOpDay, LoadOpDayPayload, proceedToDay } from './opday.actions'

export interface OpdayBaseState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  data: LoadOpDayPayload | null
}

const initialOpDayBaseState: OpdayBaseState = {
  status: 'idle',
  error: null,
  data: null,
}

export const baseReducer = createSlice({
  name: 'opdayBase',
  initialState: initialOpDayBaseState,
  reducers: {},
  extraReducers: {
    [loadOpDay.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadOpDay.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [loadOpDay.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer

export interface ProceedToDayState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string
}

const initialProceedToDayState: ProceedToDayState = {
  status: 'idle',
  error: null,
}

export const proceedToDayReducer = createSlice({
  name: 'proceedToDay',
  initialState: initialProceedToDayState,
  reducers: {},
  extraReducers: {
    [proceedToDay.pending.toString()]: (state) => {
      state.status = 'loading'
      state.error = null
    },
    [proceedToDay.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
    },
    [proceedToDay.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer

export const opdayReducer = combineReducers({
  base: baseReducer,
  proceedToDay: proceedToDayReducer,
})
